<template>
	<div style="height: 100%">
		<v-card elevation="0" class="pa-4">
			<v-row no-gutters>
				<div class="lighten-1 primary--text text-h5 font-weight-bold">
					Línea Principal
				</div>
				<v-card class="mt-2 pa-1" elevation="0" width="100%">
					<v-row class="pl-4" style="width: 100%" align="center">
						<v-col cols="12" md="3" align="center">
							<v-combobox
								class="mt-2"
								prepend-icon="mdi-phone-lock-outline"
								multiple
								chips
								deletable-chips
								:error-messages="mainError"
								:items="availablePhoneNumbers"
								dense
								@change="changedMainLineLineasAsociadas()"
								v-model="mainLine.lineasAsociadas"
							></v-combobox>
						</v-col>
						<v-col :md="ckeckGroupPermission([GROUPS.MASMOVIL]) ? 3 : 6" cols="12">
							<v-text-field
								chips
								prepend-icon="mdi-cart-arrow-down"
								:label="
									mainLine.tarifa
										? mainLine.tarifa.name
										: 'Sin tarifa'
								"
								disabled
							>
							</v-text-field>
						</v-col>
						<v-col
							v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
							md="3"
							cols="12"
						>
							<v-text-field
								chips
								:label="
									mainLine.cacharro
										? mainLine.cacharro.name
										: 'Sin terminal'
								"
								prepend-icon="mdi-cellphone"
								disabled
							>
							</v-text-field>
						</v-col>
						<v-col md="3" cols="12" align="center">
							<!-- <div> -->

							<!-- </div> -->
							<v-row align="center">
								<v-col cols="6">
									<div
										v-if="!isAvatel"
										class="
											d-flex
											flex-shrink flex-column
											pt-2
										"
									>
										<div>
											<v-icon
												size="32"
												:color="
													mainLine.seguro == null
														? 'gray'
														: 'green'
												"
											>
												mdi-shield
											</v-icon>
										</div>
										<div>
											<div class="text-overline">
												SEGURO
											</div>
										</div>
									</div>
									<div v-else>
										<v-tooltip v-if="mainLine.promotion.some((promo)=>promo.name == 'Permanencia')" top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" color="success" size="32">mdi-timer-lock-outline</v-icon>
											</template>
											<span>Permanencia</span>
										</v-tooltip>
										<v-tooltip v-else-if="!mainLine.promotion.length" top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" :color="mainLine.tarifa ? 'success' : ''" size="32">mdi-paperclip-plus</v-icon>
											</template>
											<span>Adicional</span>
										</v-tooltip>
										<v-tooltip v-else top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" color="success" size="32">mdi-account-hard-hat-outline</v-icon>
											</template>
											<span>Instalación</span>
										</v-tooltip>
									</div>
								</v-col>
								<v-col cols="6">
									<v-btn
										v-if="mainLineIsEmpty"
										depressed
										fab
										color="primary"
										class="white--text"
										@click="showConfiguratorStepper('main')"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>

									<v-btn
										v-else
										depressed
										fab
										color="red"
										@click="deletePackage(mainLine)"
										dark
									>
										<v-icon>mdi-minus</v-icon>
									</v-btn>
									<div v-if="mainLine.tarifa">
										<!-- {{ paquetePrice(mainLine) }} -->
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</v-row>

			<div v-if="!mainLineIsEmpty || !additionalLinesIsEmpty">
				<div
					class="
						mt-6
						lighten-1
						primary--text
						text-h5
						font-weight-bold
					"
				>
					Líneas Adicionales
				</div>
				<!-- {{ additionalPackages }} -->
				<v-card
					class="mt-2 pa-1"
					elevation="0"
					width="100%"
					v-for="(additional, index) in additionalPackages"
					:key="index"
				>
					<v-row class="pl-4" style="width: 100%">
						<v-col md="3" cols="12">
							<v-combobox
								chips
								class="pt-1"
								prepend-icon="mdi-phone-plus-outline"
								dense
								disabled
								v-if="additionalPackages.length - 1 == index"
							></v-combobox>
							<v-combobox
								chips
								v-else
								deletable-chips
								class="pt-1"
								:items="availablePhoneNumbers"
								prepend-icon="mdi-phone-plus-outline"
								@change="
									editAdditionalPhoneNumbers(
										additional,
										index
									)
								"
								:error-messages="asociadasError[index]"
								v-model="additional.lineasAsociadas"
								dense
								multiple
							></v-combobox>
						</v-col>
						<v-col md="3" cols="12">
							<v-text-field
								chips
								prepend-icon="mdi-cart-arrow-down"
								:label="
									additional.tarifa
										? additional.tarifa.name
										: 'Sin tarifa'
								"
								disabled
							></v-text-field>
						</v-col>
						<v-col md="3" cols="12">
							<v-text-field
								chips
								prepend-icon="mdi-cellphone"
								:label="
									additional.cacharro
										? additional.cacharro.name
										: 'Sin terminal'
								"
								disabled
							></v-text-field>
						</v-col>
						<v-col cols="12" md="3" align="center">
							<v-row align="center">
								<v-col cols="6">
									<div
										v-if="!isAvatel"
										class="
											d-flex
											flex-shrink flex-column
											pt-2
										"
									>
										<div>
											<v-icon
												size="32"
												:color="
													additional.seguro == null
														? 'gray'
														: 'green'
												"
											>
												mdi-shield
											</v-icon>
										</div>
										<div>
											<div class="text-overline">
												SEGURO
											</div>
										</div>
									</div>
									<div v-else>
										<v-tooltip v-if="additional.promotion.some((promo)=>promo.name == 'Permanencia')" top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" color="success" size="32">mdi-timer-lock-outline</v-icon>
											</template>
											<span>Permanencia</span>
										</v-tooltip>
										<v-tooltip v-else-if="!additional.promotion.length" top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" :color="additional.tarifa ? 'success' : ''" size="32">mdi-paperclip-plus</v-icon>
											</template>
											<span>Adicional</span>
										</v-tooltip>
										<v-tooltip v-else top>
											<template v-slot:activator="{ on, attrs }">
												<v-icon v-bind="attrs" v-on="on" color="success" size="32">mdi-account-hard-hat-outline</v-icon>
											</template>
											<span>Instalación</span>
										</v-tooltip>
									</div>
								</v-col>
								<v-col :class="isAvatel ? 'mt-2' : ''" cols="6">
									<v-btn
										v-if="additionalIsEmpty(additional)"
										depressed
										fab
										color="primary"
										class="white--text"
										@click="
											showConfiguratorStepper(
												'additional'
											)
										"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
									<div
										class="d-flex justify-space-between"
										v-else
									>
										<v-btn
											depressed
											fab
											color="green"
											dark
											@click="duplicate(additional)"
										>
											<v-icon
												>mdi-content-duplicate</v-icon
											>
										</v-btn>
										<v-btn
											depressed
											fab
											color="red"
											dark
											@click="deletePackage(additional)"
										>
											<v-icon>mdi-minus</v-icon>
										</v-btn>
										<!-- {{ paquetePrice(additional) }} -->
									</div>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
				</v-card>
			</div>
			<!--
            <div v-if="hasAdditionals && mainLine.family!=''">
                <div v-if="hasAdditionals" class="lighten-1 primary--text text-h6 pl-1 pb-2  ml-16 pl-16 pt-6">
                    Adicionales Fijo</div>
                <v-row class="mx-md-16 px-md-16 pt-md-2 justify-space-between"
                    v-for="fiberLines in fiberPackages.length" :key="fiberLines">
                    <v-card class="mt-2" elevation="0" width="100%">
                        <v-row class="px-4">
                            <v-col cols="3">
                                <v-combobox class="pt-1" chips prepend-icon="mdi-phone-classic" dense multiple
                                    v-model="fiberPackages[fiberLines-1].lineasAsociadas" disabled>
                                </v-combobox>
                            </v-col>
                            <v-col cols="3">
                                <v-text-field chips prepend-icon="mdi-cart-arrow-down"
                                    :label="fiberPackages[fiberLines-1].tariff" disabled></v-text-field>
                            </v-col>
                            <v-col cols="5">
                            </v-col>
                            <v-col cols="1" class="aligned">
                                <v-btn v-if="fiberPackages.length==fiberLines" depressed fab color="primary"
                                    class="white--text" @click="showConfiguratorStepper('fiber')">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>

                                <v-btn v-else depressed fab color="red" @click="deletePackage(fiberLines, 'fiber')">
                                    <v-icon>mdi-minus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-row>
            </div> -->

			<v-row
				class="mt-2 d-flex justify-space-between"
				no-gutters
				v-if="!mainLineIsEmpty || !additionalLinesIsEmpty"
			>
				<v-col :cols="!$vuetify.breakpoint.smAndDown ? '3' : ''">
					<v-row style="width: 100%">
						<v-col cols="12">
							<div
								class="
									lighten-1
									primary--text
									text-h5
									pb-2
									font-weight-bold
								"
							>
								Resumen de Precios
							</div>
							<v-card elevation="0" class="pa-4">
								<!-- <v-row no-gutters> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Total
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										append-outer-icon="mdi-currency-eur"
										v-model="totalPrice"
										disabled
										prepend-icon="mdi-cash-multiple"
									>
									</v-text-field>
								</v-card>
								<!-- </v-row> -->

								<!-- <v-row class="px-12 pt-0"> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Diferencia Mes
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										append-outer-icon="mdi-currency-eur"
										disabled
										v-model="diffPrecioActualAnterior"
										prepend-icon="mdi-calendar-cursor"
									>
									</v-text-field>
								</v-card>
								<!-- </v-row> -->

								<!-- <v-row class="px-12
                                        pt-0
                                        pb-4"> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Diferencia Año
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										append-outer-icon="mdi-currency-eur"
										disabled
										v-model="diffPrecioActualAnteriorAnio"
										prepend-icon="mdi-calendar-clock"
									>
									</v-text-field>
								</v-card>
								<!-- </v-row> -->
							</v-card>
						</v-col>
					</v-row>
				</v-col>
				<v-col :cols="!$vuetify.breakpoint.smAndDown ? '9' : '12'">
					<v-row>
						<v-col
							:cols="!$vuetify.breakpoint.smAndDown ? '3' : '12'"
							v-for="(paquete, index) in paquetesSVA"
							:key="index"
						>
							<div
								v-if="index == 0"
								class="
									lighten-1
									primary--text
									text-h5
									font-weight-bold
									pb-2
								"
							>
								SVA
							</div>
							<v-card
								outlined
								elevation="0"
								:class="index == 0 ? 'pa-4' : 'mt-10 pa-4'"
							>
								<div class="d-flex justify-end">
									<v-btn
										color="red darken-1"
										fab
										dark
										small
										@click="deleteSVA(index)"
										absolute
										depressed
										class="borderButton white--text"
									>
										<v-icon>mdi-minus</v-icon>
									</v-btn>
								</div>

								<!-- <v-row no-gutters> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Nombre Servicio
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-image-text"
										:value="paquete.tarifa.name"
									>
									</v-text-field>
								</v-card>
								<!-- </v-row> -->

								<!-- <v-row class="px-12 pt-0"> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Permanencia
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-camera-timer"
										:value="paquete.tarifa.permanence"
									>
									</v-text-field>
								</v-card>
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Precio
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-cash-100"
										:value="
											(
												paquete.tarifa.price * iva
											).toFixed(2) + ' €'
										"
									>
									</v-text-field>
								</v-card>
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Promociones
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-sale"
										:value="
											promosToString(paquete.promotion)
										"
									>
									</v-text-field>
								</v-card>
							</v-card>
						</v-col>
						<v-col xl="3" lg="3" md="3" sm="12" xs="12">
							<div
								v-if="paquetesSVA.length == 0"
								class="
									lighten-1
									primary--text
									text-h5
									font-weight-bold
									pb-2
								"
							>
								SVAs
							</div>
							<v-card
								elevation="0"
								:class="
									paquetesSVA.length == 0
										? 'pa-4'
										: 'pa-4 mt-10'
								"
							>
								<div
									class="d-flex justify-end"
									v-if="!mainLineIsEmpty"
								>
									<v-btn
										color="primary"
										fab
										dark
										small
										@click="showAditionalStepper"
										absolute
										depressed
										class="borderButton white--text"
									>
										<v-icon>mdi-plus</v-icon>
									</v-btn>
								</div>

								<!-- <v-row no-gutters> -->
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Nombre Servicio
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-image-text"
										value=""
									>
									</v-text-field>
								</v-card>
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Permanencia
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-camera-timer"
										value=""
									>
									</v-text-field>
								</v-card>
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Precio
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-cash-100"
										value=""
									>
									</v-text-field>
								</v-card>
								<div
									class="
										lighten-1
										primary--text
										text-h7 text-overline
									"
								>
									Promociones
								</div>
								<v-card elevation="0">
									<v-text-field
										dense
										disabled
										prepend-icon="mdi-sale"
										value=""
									>
									</v-text-field>
								</v-card>
							</v-card>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-card>

		<ConfiguratorStepper />
		<ConfiguratorAditional />
		<PresetBase />
	</div>
</template>

<script>
import ConfiguratorStepper from '@/components/ComercialTeletrabajo/OfferConfigurator/ConfiguratorStepper.vue';
import ConfiguratorAditional from '@/components/ComercialTeletrabajo/OfferConfigurator/ConfiguratorAditional.vue';
import PresetBase from '@/components/ComercialTeletrabajo/OfferConfigurator/Presets/PresetBase.vue';
import defaultPaqueteForm from '@/util/offerConfigurator/defaultPaqueteForm.js';
import { mapState, mapGetters } from 'vuex';
import { clone } from '@/util/libUtil.js';

export default {
	name: 'ConfiguratorContainer',
	components: {
		ConfiguratorStepper,
		ConfiguratorAditional,
		PresetBase,
	},
	data: () => ({
		mainError: [],
		asociadasError: [],
		asociadasInput: [],
		mainLineInput: [],
	}),
	computed: {
		availablePhoneNumbers() {
			let clientePhoneNumbers = this.cliente
				? this.cliente.telefonosContacto
				: [];
			let mainLinePhoneNumbers = this.mainLine.lineasAsociadas;
			let additionalPhoneNumbers = [];

			this.additionalPackages.forEach(({ lineasAsociadas }) => {
				lineasAsociadas.forEach((numero) => {
					additionalPhoneNumbers.push(numero);
				});
			});

			return clientePhoneNumbers.filter(
				(numero) =>
					!mainLinePhoneNumbers.includes(numero) &&
					!additionalPhoneNumbers.includes(numero)
			);
		},
		...mapGetters('configuradorOferta', ['iva', 'paquetePrice']),
		...mapGetters('login', ['isAvatel']),
		diffPrecioActualAnterior() {
			return this.precioMensOtro <= 0
				? ''
				: (this.precioMensOtro - this.totalPrice).toFixed(2);
		},
		diffPrecioActualAnteriorAnio() {
			return this.precioMensOtro <= 0
				? ''
				: (this.diffPrecioActualAnterior * 12).toFixed(2);
		},
		mainLineIsEmpty() {
			return (
				JSON.stringify(this.mainLine) ==
				JSON.stringify({
					...defaultPaqueteForm,
					tipoLinea: 'LINEA_PRINCIPAL',
				})
			);
		},
		additionalLinesIsEmpty() {
			return !(
				this.additionalPackages &&
				this.additionalPackages.length &&
				this.additionalPackages[0].tipoLinea == 'LINEA_ADICIONAL'
			);
		},
		hasAdditionals() {
			return this.$store.state.configuradorOferta.hasAdditionals;
		},
		numFibraFijo: {
			get() {
				return this.$store.state.configuradorOferta.numFibraFijo;
			},
			set(val) {
				this.$store.commit('configuradorOferta/numFibraFijo', val);
			},
		},
		totalSVA: {
			get() {
				return this.$store.state.configuradorOferta.totalSVA;
			},
			set(val) {
				this.$store.commit('configuradorOferta/totalSVA', val);
			},
		},
		fiberPackages: {
			get() {
				return [];
				// return this.$store.state.configuradorOferta.fiberPackages
			},
		},
		// mainLine: {
		//     get() {
		//         return {
		//             lineasAsociadas: [],
		//             tariff: ''
		//         }
		//         // return this.$store.state.configuradorOferta.mainLine
		//     }
		// },
		// totalPrice: {
		// 	get() {
		// 		return this.$store.state.configuradorOferta.totalPrice.toFixed(
		// 			2
		// 		);
		// 	},
		// 	set(val) {
		// 		this.$store.commit('configuradorOferta/totalPrice', val);
		// 	},
		// },
		precioMensOtro: {
			get() {
				return this.$store.state.configuradorOferta.precioMensOtro;
			},
			set(val) {
				this.$store.commit('configuradorOferta/precioMensOtro', val);
			},
		},
		precioActualYG: {
			get() {
				return this.$store.state.configuradorOferta.precioActualYG;
			},
			set(val) {
				this.$store.commit('configuradorOferta/precioActualYG', val);
			},
		},
		additionalPackages() {
			return [
				...this.$store.getters['configuradorOferta/additionalPackages'],
				clone(defaultPaqueteForm),
			];
		},
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			ckeckGroupPermission: 'ckeckGroupPermission',
		}),
		...mapState('configuradorOferta', {
			loadingTariffs: (state) => state.loadingTariffs,
			cliente: (state) => state.cliente,
			tariffs: (state) => state.tariffs,
			promotions: (state) => state.promotions,
			paquetes: (state) => state.atencion.oferta.paquetes,
			atencion: (state) => state.atencion,
			principal: (state) =>
				state.atencion.oferta.paquetes.find(
					({ tipoLinea }) => tipoLinea == 'LINEA_PRINCIPAL'
				),
			paquetesSVA: (state) =>
				state.atencion.oferta.paquetes.filter(
					(paquete) => paquete.tipoLinea == 'LINEA_ADICIONAL_SVA'
				),
		}),
		...mapGetters('configuradorOferta', {
			selectedSVAs: 'selectedSVAs',
			mainLine: 'mainLine',
			totalPrice: 'totalPrice',
		}),
	},
	methods: {
		promosToString(promos) {
			let aux = [];
			promos.forEach((promo) => {
				let name = promo.name;
				if (!name) name = promo.id;

				aux.push(name);
			});

			return aux.join(', ');
		},
		editAdditionalPhoneNumbers(additional, index) {
			let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
			let copy = [];
			let mainLinePhoneNumbers = this.mainLine.lineasAsociadas;
			let additionalPhoneNumbers = [];

			this.additionalPackages.forEach((adicional) => {
				if (adicional != additional)
					adicional.lineasAsociadas.forEach((numero) => {
						additionalPhoneNumbers.push(numero);
					});
			});

			additional.lineasAsociadas.forEach((line) => {
				if (
					regexTelefono.test(line) &&
					!mainLinePhoneNumbers.includes(line) &&
					!additionalPhoneNumbers.includes(line) &&
					additional.lineasAsociadas.filter((linea) => linea == line)
						.length < 2
				)
					copy.push(line);
				else {
					this.asociadasError[index] =
						'Alguno de los números es repetido o no es correcto y se ha eliminado';
					setTimeout(() => {
						this.asociadasError.splice(index, 1);
					}, 2500);
				}
			});

			additional.lineasAsociadas = copy;
		},
		submitOffer() {
			this.$store.dispatch('configuradorOferta/guardarOferta');
		},
		showConfiguratorStepper(type) {
			this.$store.commit('configuradorOferta/stepperType', type);
			this.$store.commit(
				'configuradorOferta/isOpenConfiguratorStepper',
				true
			);
		},
		showAditionalStepper() {
			this.$store.commit(
				'configuradorOferta/isOpenAditionalStepper',
				true
			);
		},
		deletePackage(paquete) {
			if (paquete.tipoLinea == 'LINEA_PRINCIPAL') {
				this.$store.commit('configuradorOferta/presetMainUsed', false);
			}

			this.$store.commit('configuradorOferta/packagesPop', paquete);
		},
		duplicate(paquete) {
			this.$store.dispatch(
				'configuradorOferta/packagesDuplicate',
				paquete
			);
		},
		deleteSVA(index) {
			// indeOf no lo encuentra directamente FML
			let svaPackage = this.paquetes.find(
				(svaPackage) => this.paquetesSVA[index] == svaPackage
			);
			this.paquetes.splice(this.paquetes.indexOf(svaPackage), 1);

			// let selectedSVA = clone(this.principal.svas);
			// let selectedPromos = clone(this.principal.promotion);
			// let aux = [];

			// selectedPromos.forEach((promo) => {
			//     if (
			//         !sva.promotions.some(
			//             (promotion) => promo.id == promotion.id
			//         )
			//     ) {
			//         aux.push(promo);
			//     }
			// });

			// selectedSVA.forEach((element, index) => {
			//     if (element.id == sva.id) selectedSVA.splice(index, 1);
			// });

			// this.principal.svas = selectedSVA;
			// this.principal.promotion = aux;
		},
		additionalIsEmpty(additional) {
			return (
				JSON.stringify(additional) == JSON.stringify(defaultPaqueteForm)
			);
		},
		changedMainLineLineasAsociadas() {
			if (
				!this.atencion.oferta.paquetes.some(
					({ tipoLinea }) => tipoLinea === 'LINEA_PRINCIPAL'
				)
			) {
				this.$store.commit('configuradorOferta/package', this.mainLine);
			}

			let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
			let copy = [];
			let additionalPhoneNumbers = [];

			this.additionalPackages.forEach((adicional) => {
				adicional.lineasAsociadas.forEach((numero) => {
					additionalPhoneNumbers.push(numero);
				});
			});

			this.mainLine.lineasAsociadas.forEach((line) => {
				if (
					regexTelefono.test(line) &&
					!additionalPhoneNumbers.includes(line) &&
					this.mainLine.lineasAsociadas.filter(
						(linea) => linea == line
					).length < 2
				)
					copy.push(line);
				else {
					this.mainError =
						'Alguno de los números es repetido o no es correcto y se ha eliminado';
					setTimeout(() => {
						this.mainError = [];
					}, 2500);
				}
			});

			this.mainLine.lineasAsociadas = copy;
		},
	},
};
</script>

<style>
.aligned {
	align-self: center;
	text-align: center;
}

.borderButton {
	margin-right: -12px;
	margin-top: -12px;
}
</style>